<template>
  <section v-click-outside="tryClose">
    <button type="button" class="c-head__control" :class="{ 'c-head__control--expanded': isExpanded }" @click="tryOpen()">
      <div :class="`c-icon-${ isExpanded ? 'times' : 'bars' }`"></div>
    </button>
    <nav class="c-nav-slider" :class="{ 'c-nav-slider--expanded': isExpanded }" :style="{ height: isExpanded ? containerHeight : undefined }" ref="container">
      <div class="c-nav-slider__inner">
        <slot></slot>
      </div>
    </nav>
  </section>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';

import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const ui = namespace('ui');

@Component
export default class NavSlider extends BaseComponent {
  @ui.State('mobileMenuToggled') protected readonly isExpanded: boolean;
  @ui.Mutation('toggleMobileMenu') protected toggle: (isToggled?: boolean) => void;
  @ui.State('enquireFormVisible') protected enquireFormVisible: boolean;
  @ui.Mutation('showEnquireForm') protected showEnquireForm: (isVisible: boolean) => void;

  protected get containerHeight(): string {
    return `calc(100dvh - ${ (this.$refs.container as HTMLElement).getBoundingClientRect().top }px)`;
  }

  protected tryOpen(state: boolean | null = null): void {
    state = state !== null ? state : !this.isExpanded;
    if (!state) {
      if (!this.enquireFormVisible) {
        this.showEnquireForm(true);
      }
      // EventBus.$emit('mobileMenu:reset');
      this.toggle(state);

      return;
    }
    if (this.enquireFormVisible) {
      this.showEnquireForm(false);
    }
    this.toggle(state);
  }

  protected tryClose() {
    if (this.isExpanded) {
      this.toggle(false);
    }
  }
}
</script>
